export const BUILDING_OPTIONS_WITH_AVATAR_PARAMS = {
  with_field: 'avatar',
}

export const BUILDINGS_ACTION_ARCHIVE = 'archive_item'

export const BUILDINGS_ACTION_ARCHIVE_MASS = 'archive_mass'

export const BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP = 'update_building_groups'

export const BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP_MASS =
  'update_buildings_mass'

export const BUILDINGS_ACTION_EDIT_MANAGERS = 'update_responsible_users'

export const BUILDINGS_ACTION_EDIT_MANAGERS_MASS =
  'update_responsible_users_mass'

export const BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS = 'update_property_owners'

export const BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS_MASS =
  'update_property_owners_mass'

export const BUILDINGS_ACTION_REMOVE = 'remove_item'

export const BUILDINGS_ACTION_REMOVE_MASS = 'remove_mass'

export const BUILDINGS_ACTION_REMOVE_FROM_GROUP = 'remove_from_building_group'

export const BUILDINGS_ACTION_REMOVE_FROM_GROUP_MASS =
  'remove_from_building_group_mass'

export const BUILDINGS_ACTION_RESTORE = 'restore_item'

export const BUILDINGS_ACTION_RESTORE_MASS = 'restore_mass'

export const BUILDINGS_MASS_ACTION_FIND_AND_REMOVE_COMMAND = 'find_and_remove'

export const BUILDINGS_MASS_ACTION_NAMES = {
  [BUILDINGS_ACTION_ARCHIVE]: 'archive',
  [BUILDINGS_ACTION_ARCHIVE_MASS]: 'archive',
  [BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP]: 'update_building_groups',
  [BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP_MASS]: 'update_building_groups',
  [BUILDINGS_ACTION_EDIT_MANAGERS]: 'update_responsible_users',
  [BUILDINGS_ACTION_EDIT_MANAGERS_MASS]: 'update_responsible_users',
  [BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS]: 'update_property_owners',
  [BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS_MASS]: 'update_property_owners',
  [BUILDINGS_ACTION_REMOVE]: 'update_staff_member_buildings',
  [BUILDINGS_ACTION_REMOVE_MASS]: 'update_staff_member_buildings',
  [BUILDINGS_ACTION_RESTORE]: 'restore',
  [BUILDINGS_ACTION_RESTORE_MASS]: 'restore',
}
